import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import { LARGE_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
// Addresses
import { getSpookySwapAddress } from 'utils/addressHelpers'

export const tokenApprove = async (tokenContract, amount) => {
  const receipt = await tokenContract.approve(ethers.utils.parseEther(`${amount}`))
  return receipt
}

export const alienIn = async (masterChefContract, amount, lpAddress, account, decimals = DEFAULT_TOKEN_DECIMAL) => {
  const amountGwei = new BigNumber(amount).times(decimals).toString()

  const options = {
    gasLimit: LARGE_GAS_LIMIT,
    value: amountGwei,
  }
  const tx = await masterChefContract.alienIn(lpAddress, getSpookySwapAddress(), account, options)
  const receipt = tx.wait()
  return receipt
}

export const alienOut = async (masterChefContract, amount, lpAddress, account, decimals = DEFAULT_TOKEN_DECIMAL) => {
  const amountGwei = new BigNumber(amount).times(decimals).toString()

  const options = {
    gasLimit: LARGE_GAS_LIMIT,
  }

  const tx = await masterChefContract.alienOut(lpAddress, amountGwei, getSpookySwapAddress(), account, options)
  const receipt = tx.wait()
  return receipt
}

export const alienInToken = async (
  masterChefContract,
  tokenAddress,
  amount,
  lpAddress,
  account,
  decimals = DEFAULT_TOKEN_DECIMAL,
) => {
  const options = {
    gasLimit: LARGE_GAS_LIMIT,
  }
  const amountGwei = new BigNumber(amount).times(decimals).toString()

  const tx = await masterChefContract.alienInToken(
    tokenAddress,
    amountGwei,
    lpAddress,
    getSpookySwapAddress(),
    account,
    options,
  )
  const receipt = tx.wait()

  return receipt
}

export const alienOutToken = async (
  masterChefContract,
  amount,
  lpAddress,
  tokenAddress,
  account,
  decimals = DEFAULT_TOKEN_DECIMAL,
) => {
  const options = {
    gasLimit: LARGE_GAS_LIMIT,
  }

  const amountGwei = new BigNumber(amount).times(decimals).toString()

  const tx = await masterChefContract.alienOutToken(
    lpAddress,
    amountGwei,
    tokenAddress,
    getSpookySwapAddress(),
    account,
    options,
  )
  const receipt = tx.wait()

  return receipt
}

export const estimateZapInToken = async (
  masterChefContract,
  amount,
  tokenAddress,
  lpAddress,
  decimals = DEFAULT_TOKEN_DECIMAL,
) => {
  const options = {
    gasLimit: LARGE_GAS_LIMIT,
  }

  const amountGwei = new BigNumber(amount).times(decimals).toString()

  const receipt = await masterChefContract.estimateZapInToken(
    tokenAddress,
    lpAddress,
    getSpookySwapAddress(),
    amountGwei,
    options,
  )

  return receipt
}
